import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { useGetObsErrorsQuery } from '../../redux/services/obs-api';
import { ObsError } from './ObsError';

const fmtDate = value => (value ? new Date(value).toLocaleString() : '—');

// Agregación por stackHash + evento: convierte miles de líneas de ruido en una
// lista corta de problemas distintos.
function ErrorsTab() {
  const { data, isLoading, isFetching, error } = useGetObsErrorsQuery(
    {},
    { pollingInterval: 30000 }
  );

  if (isLoading) return <CircularProgress sx={{ m: 4 }} />;
  if (error) return <ObsError error={error} context="los errores agrupados" />;

  const rows = data?.results || [];

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {rows.length} problemas distintos{isFetching ? ' · refrescando…' : ''}
      </Typography>
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="right">Veces</TableCell>
              <TableCell>Evento</TableCell>
              <TableCell>Error</TableCell>
              <TableCell>Primera vez</TableCell>
              <TableCell>Última vez</TableCell>
              <TableCell align="right">Dispositivos</TableCell>
              <TableCell>Versiones</TableCell>
              <TableCell>Plataformas</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(group => (
              <TableRow key={`${group.stackHash || 'nohash'}-${group.event}`} hover>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {group.count}
                  </Typography>
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{group.event}</TableCell>
                <TableCell sx={{ maxWidth: 360, overflow: 'hidden' }}>
                  <Typography
                    variant="body2"
                    noWrap
                    title={group.lastErrorMessage || group.lastMessage}
                    sx={{ overflowWrap: 'anywhere' }}
                  >
                    {group.lastErrorMessage || group.lastMessage || '—'}
                  </Typography>
                  {group.stackHash && (
                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                      {group.stackHash}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>{fmtDate(group.firstSeen)}</TableCell>
                <TableCell>{fmtDate(group.lastSeen)}</TableCell>
                <TableCell align="right">{group.installCount}</TableCell>
                <TableCell sx={{ maxWidth: 200 }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {(group.versions || []).map(v => (
                      <Chip key={v} size="small" label={v} />
                    ))}
                  </Box>
                </TableCell>
                <TableCell>{(group.platforms || []).join(', ') || '—'}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={8}>
                  <Typography sx={{ p: 2 }} color="text.secondary">
                    Sin errores registrados. Ojalá siga así durante el camporee.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ErrorsTab;
